import feederMapData from './feederMap.json';

export const DEFAULT_FEEDER_ID = 'MA101';

const { substationsById, feedersById } = feederMapData;

const sortByName = (a, b) => {
  const left = String(a.name ?? a.id ?? '').toLowerCase();
  const right = String(b.name ?? b.id ?? '').toLowerCase();
  return left.localeCompare(right);
};

const substations = Object.values(substationsById).slice().sort(sortByName);

const feeders = Object.values(feedersById).slice().sort(sortByName);

const feedersBySubstationId = feeders.reduce((acc, feeder) => {
  const list = acc[feeder.substationId] || (acc[feeder.substationId] = []);
  list.push(feeder);
  return acc;
}, {});

Object.keys(feedersBySubstationId).forEach((substationId) => {
  feedersBySubstationId[substationId].sort(sortByName);
});

export { substationsById, feedersById, substations, feeders, feedersBySubstationId };

export const getSubstationForFeeder = (feederId) => {
  const feeder = feedersById[feederId];
  if (!feeder) {
    return null;
  }
  return substationsById[feeder.substationId] || null;
};
